import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { Offcanvas } from "react-bootstrap";
import Menu from "./Menu";
import "../css/Navbar.css";
import { logo } from "../static";

const Navbar = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const location = useLocation(); // Para marcar o link ativo

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header className={`main-nav-wrapper ${isSticky ? "sticky-nav" : ""}`}>
        <div className="container d-flex align-items-center justify-content-between py-3">
          
          {/* Logo */}
          <Link to="/" className="navbar-logo">
            <img src={logo} alt="Logo Hospital" />
          </Link>

          {/* Links Desktop */}
          <nav className="d-none d-lg-block">
            <ul className="nav-list-flat d-flex m-0 p-0">
              {Menu.map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.path} 
                    className={`nav-link-item ${location.pathname === item.path ? "active" : ""}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Redes Sociais ou Call to Action */}
          <div className="nav-socials d-none d-lg-flex gap-3">
            <a href="#" className="social-icon"><FaFacebookF /></a>
            <a href="#" className="social-icon"><FaInstagram /></a>
            <a href="#" className="social-icon"><FaYoutube /></a>
          </div>

          {/* Botão Mobile */}
          <button className="mobile-menu-btn d-lg-none" onClick={() => setShowOffcanvas(true)}>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
          </button>
        </div>
      </header>

      {/* Menu Mobile (Offcanvas) */}
      <Offcanvas show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Navegação</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="list-unstyled mobile-flat-list">
            {Menu.map((item, index) => (
              <li key={index} className="mb-4">
                <Link 
                  to={item.path} 
                  className="mobile-link" 
                  onClick={() => setShowOffcanvas(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Navbar;